import React from 'react';
import { IAddress } from 'Modules/SearchAddress/types';
import { colors } from 'constants/colors';
import { ADDRESS_DROPDOWN_LIST_ITEM_TEST_ID, ADDRESS_DROPDOWN_LIST_TEST_ID } from 'Components/SearchAddress/constants';
import { Box } from '@igooods/ui-kit';
import Text from 'Components/Typography/Text';
import { FontSize } from 'theme';
import HighlightText from 'Components/HighlightText';
import DropdownScrollbar from '../ScrollbarDropdown';

interface IAddressDropdownListProps {
  list: IAddress[];
  onSelectAddress: (address: IAddress) => void;
  hoveredIndex: number;
}

const AddressDropdownList: React.FC<IAddressDropdownListProps> = ({
  list,
  onSelectAddress,
  hoveredIndex,
}: IAddressDropdownListProps) => {
  return (
    <DropdownScrollbar testId={ADDRESS_DROPDOWN_LIST_TEST_ID}>
      {list.map((item, i) => (
        <HighlightText
          size={FontSize.s}
          key={`${item.name}${i}`}
          hovered={i === hoveredIndex}
          testId={ADDRESS_DROPDOWN_LIST_ITEM_TEST_ID}
          onClick={() => onSelectAddress(item)}
          title={item.name}
          {...(item.city && {
            subtitle: (
              <Box mt={1}>
                <Text size={FontSize.xxs} color={colors.blackRussian} opacity={0.4}>
                  {item.city}
                </Text>
              </Box>
            ),
          })}
        />
      ))}
    </DropdownScrollbar>
  );
};

export default AddressDropdownList;
